var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 76.25H31.5V72.5C31.5 69.3931 34.0181 66.875 37.125 66.875H70.875C73.9819 66.875 76.5 69.3931 76.5 72.5V76.25ZM54 31.25C52.9631 31.25 52.125 30.41 52.125 29.375V25.625C52.125 24.59 52.9631 23.75 54 23.75C55.0369 23.75 55.875 24.59 55.875 25.625V29.375C55.875 30.41 55.0369 31.25 54 31.25ZM39.4163 37.2913C38.9363 37.2913 38.4562 37.1075 38.0906 36.7419L35.4394 34.0906C34.7062 33.3575 34.7062 32.1725 35.4394 31.4394C36.1725 30.7062 37.3575 30.7062 38.0906 31.4394L40.7419 34.0906C41.475 34.8237 41.475 36.0087 40.7419 36.7419C40.3744 37.1075 39.8963 37.2913 39.4163 37.2913ZM68.5837 37.2913C68.1037 37.2913 67.6237 37.1075 67.2581 36.7419C66.525 36.0087 66.525 34.8237 67.2581 34.0906L69.9094 31.4394C70.6425 30.7062 71.8275 30.7062 72.5606 31.4394C73.2938 32.1725 73.2938 33.3575 72.5606 34.0906L69.9094 36.7419C69.5438 37.1075 69.0637 37.2913 68.5837 37.2913ZM33.375 51.875H29.625C28.5881 51.875 27.75 51.035 27.75 50C27.75 48.965 28.5881 48.125 29.625 48.125H33.375C34.4119 48.125 35.25 48.965 35.25 50C35.25 51.035 34.4119 51.875 33.375 51.875ZM78.375 51.875H74.625C73.5881 51.875 72.75 51.035 72.75 50C72.75 48.965 73.5881 48.125 74.625 48.125H78.375C79.4119 48.125 80.25 48.965 80.25 50C80.25 51.035 79.4119 51.875 78.375 51.875ZM69 63.125V50C69 41.7294 62.2706 35 54 35C45.7294 35 39 41.7294 39 50V63.125H69ZM54.0638 42.2675C54.3225 41.2644 55.3463 40.6662 56.3475 40.9212C59.6456 41.7744 62.2256 44.3544 63.0787 47.6544C63.3394 48.6575 62.7356 49.6794 61.7344 49.94C61.5769 49.9813 61.4175 50 61.2619 50C60.4294 50 59.6663 49.4394 59.4488 48.5938C58.9369 46.6119 57.3863 45.065 55.41 44.5531C54.4069 44.2944 53.805 43.2706 54.0638 42.2675Z",
    fill: "#8FB16A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_438",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.694118 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_438",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmSystem);
export default __webpack_public_path__ + "static/media/alarmSystem.89ed323000bf89cd550aafc22749ad58.svg";
export { ForwardRef as ReactComponent };